import { Link } from 'react-router-dom';
import NavigationMenu from '../../components/feature/NavigationMenu';

export default function TechnologyPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <header className="absolute top-0 left-0 right-0 z-50 bg-gradient-to-r from-teal-600/90 to-blue-600/90 backdrop-blur-sm">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="text-2xl font-bold text-white" style={{ fontFamily: '"Pacifico", serif' }}>
              Marine Pad
            </Link>
            <NavigationMenu />
            <Link
              to="/crowdfunding"
              className="bg-white text-teal-600 px-6 py-2 rounded-full font-semibold hover:bg-teal-50 transition-colors whitespace-nowrap"
            >
              Support Us
            </Link>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-gradient-to-r from-teal-600 to-blue-600 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            Marine Pad Technology
          </h1>
          <p className="text-xl md:text-2xl max-w-4xl mx-auto leading-relaxed">
            World's First Daily-Use Natural Absorbent for Crowdfunding Campaign
          </p>
        </div>
      </section>

      {/* Main Technology Content */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Technology Overview */}
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-8">
              Revolutionary Bio-SA Technology
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <img 
                  src="https://static.readdy.ai/image/e97325bca996f1ce3b54a2c00c06237a/e00f517d5013182058eb37c52f56f6c7.jpeg"
                  alt="Bio-SA Technology Development"
                  className="rounded-lg shadow-lg object-cover w-full h-80"
                />
              </div>
              <div className="text-left">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">
                  Absorption Capacity: 2.5 times higher than conventional products
                </h3>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <div className="w-8 h-8 flex items-center justify-center bg-teal-100 rounded-full mr-4 mt-1">
                      <i className="ri-drop-line text-teal-600"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">Superior Absorption</h4>
                      <p className="text-gray-600">Absorbs 25ml (2.5 times conventional), provides complete protection for all flow levels</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 flex items-center justify-center bg-blue-100 rounded-full mr-4 mt-1">
                      <i className="ri-time-line text-blue-600"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">Instant Absorption</h4>
                      <p className="text-gray-600">Rapid wicking technology prevents leakage and maintains dryness</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 flex items-center justify-center bg-green-100 rounded-full mr-4 mt-1">
                      <i className="ri-shield-check-line text-green-600"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">Safe & Secure</h4>
                      <p className="text-gray-600">Complete protection with optimal comfort and safety</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Comparison Chart */}
          <div className="mb-20">
            <h3 className="text-3xl font-bold text-gray-900 text-center mb-12">
              Technology Comparison
            </h3>
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-gradient-to-r from-teal-600 to-blue-600 text-white">
                    <tr>
                      <th className="px-6 py-4 text-left font-semibold">Feature</th>
                      <th className="px-6 py-4 text-center font-semibold">Marine Pad (Bio-SA)</th>
                      <th className="px-6 py-4 text-center font-semibold">Conventional SAP</th>
                      <th className="px-6 py-4 text-center font-semibold">Other Organic Pads</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="bg-gray-50">
                      <td className="px-6 py-4 font-semibold text-gray-900">100% Biodegradable</td>
                      <td className="px-6 py-4 text-center text-green-600 font-bold">✅</td>
                      <td className="px-6 py-4 text-center text-red-600 font-bold">❌</td>
                      <td className="px-6 py-4 text-center text-red-600 font-bold">❌</td>
                    </tr>
                    <tr className="bg-white">
                      <td className="px-6 py-4 font-semibold text-gray-900">No Chemical SAP</td>
                      <td className="px-6 py-4 text-center text-green-600 font-bold">✅</td>
                      <td className="px-6 py-4 text-center text-red-600 font-bold">❌</td>
                      <td className="px-6 py-4 text-center text-red-600 font-bold">❌</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="px-6 py-4 font-semibold text-gray-900">Superior Performance</td>
                      <td className="px-6 py-4 text-center text-green-600 font-bold">✅</td>
                      <td className="px-6 py-4 text-center text-green-600 font-bold">✅</td>
                      <td className="px-6 py-4 text-center text-yellow-600 font-bold">❓</td>
                    </tr>
                    <tr className="bg-white">
                      <td className="px-6 py-4 font-semibold text-gray-900">Skin Safety</td>
                      <td className="px-6 py-4 text-center text-green-600 font-bold">✅</td>
                      <td className="px-6 py-4 text-center text-red-600 font-bold">❌</td>
                      <td className="px-6 py-4 text-center text-green-600 font-bold">✅</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="px-6 py-4 font-semibold text-gray-900">Environmental Impact</td>
                      <td className="px-6 py-4 text-center text-green-600 font-bold">✅</td>
                      <td className="px-6 py-4 text-center text-red-600 font-bold">❌</td>
                      <td className="px-6 py-4 text-center text-yellow-600 font-bold">❓</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Bio-SA Technology Details */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                Bio-SA: Marine-Based Innovation
              </h3>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Our proprietary Bio-SA (Bio Super Absorbent) technology is derived from chitin, 
                the second most abundant biopolymer on Earth, found in crustacean shells.
              </p>
              <div className="space-y-4">
                <div className="bg-teal-50 p-4 rounded-lg border-l-4 border-teal-600">
                  <h4 className="font-semibold text-teal-800 mb-2">Nano-Fiber Structure</h4>
                  <p className="text-teal-700">
                    Advanced nano-fiber technology creates a capillary network for superior fluid management
                  </p>
                </div>
                <div className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-600">
                  <h4 className="font-semibold text-blue-800 mb-2">Natural Antimicrobial</h4>
                  <p className="text-blue-700">
                    Chitin's inherent antimicrobial properties provide natural protection
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg border-l-4 border-green-600">
                  <h4 className="font-semibold text-green-800 mb-2">Complete Biodegradability</h4>
                  <p className="text-green-700">
                    Returns to nature within 6 months, leaving no environmental trace
                  </p>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://public.readdy.ai/ai/img_res/316e24bf022420ea2226b822ff8b94b8.jpg"
                alt="Bio-SA Nano-Fiber Technology"
                className="rounded-lg shadow-lg object-cover w-full h-96"
              />
            </div>
          </div>

          {/* Research & Development */}
          <div className="bg-gray-50 p-12 rounded-lg mb-20">
            <div className="text-center mb-12">
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                20 Years of Marine Research Excellence
              </h3>
              <p className="text-xl text-gray-600 max-w-4xl mx-auto">
                Led by Professor Yung-Bum Seo and founder Yun-Young Heo, our research team has dedicated 
                two decades to unlocking the potential of marine-based materials.
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-6">
                  <i className="ri-microscope-line text-2xl text-teal-600"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-4">Advanced Research</h4>
                <p className="text-gray-700">
                  Cutting-edge biotechnology research in marine polymer extraction and processing
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-full mx-auto mb-6">
                  <i className="ri-award-line text-2xl text-blue-600"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-4">NET Certification</h4>
                <p className="text-gray-700">
                  South Korea's New Excellent Technology certification validates our innovation
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-6">
                  <i className="ri-earth-line text-2xl text-green-600"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-4">Global Impact</h4>
                <p className="text-gray-700">
                  First successful SAP alternative development, setting new industry standards
                </p>
              </div>
            </div>
          </div>

          {/* Medical Grade Safety */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
            <div>
              <img 
                src="https://static.readdy.ai/image/e97325bca996f1ce3b54a2c00c06237a/7cbc5b8cd88441e947aac0d54765be34.jpeg"
                alt="Medical Grade Testing"
                className="rounded-lg shadow-lg object-cover w-full h-80"
              />
            </div>
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                Medical Grade Safety Standards
              </h3>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Marine Pad meets the highest medical device standards, ensuring complete safety 
                and biocompatibility for intimate use.
              </p>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-8 h-8 flex items-center justify-center bg-red-100 rounded-full mr-4 mt-1">
                    <i className="ri-heart-pulse-line text-red-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Biocompatibility Tested</h4>
                    <p className="text-gray-600">Rigorous testing ensures no adverse reactions or irritation</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 flex items-center justify-center bg-purple-100 rounded-full mr-4 mt-1">
                    <i className="ri-shield-check-line text-purple-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Dermatologically Approved</h4>
                    <p className="text-gray-600">Suitable for sensitive skin with hypoallergenic properties</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 flex items-center justify-center bg-orange-100 rounded-full mr-4 mt-1">
                    <i className="ri-medicine-bottle-line text-orange-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Medical Suture Grade</h4>
                    <p className="text-gray-600">Same chitin source used in medical sutures for internal healing</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Environmental Impact */}
          <div className="bg-gradient-to-r from-teal-600 to-blue-600 text-white p-12 rounded-lg">
            <div className="text-center mb-12">
              <h3 className="text-3xl font-bold mb-6">
                Environmental Revolution
              </h3>
              <p className="text-xl max-w-4xl mx-auto leading-relaxed">
                Marine Pad represents the world's first successful replacement for environmentally 
                destructive SAP technology in feminine hygiene products.
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-lg">
                <h4 className="text-xl font-bold mb-4">The Problem We Solved</h4>
                <ul className="space-y-2">
                  <li className="flex items-center">
                    <i className="ri-close-circle-line text-red-300 mr-3"></i>
                    45 billion pads disposed annually worldwide
                  </li>
                  <li className="flex items-center">
                    <i className="ri-close-circle-line text-red-300 mr-3"></i>
                    SAP breaks down into microplastics
                  </li>
                  <li className="flex items-center">
                    <i className="ri-close-circle-line text-red-300 mr-3"></i>
                    500-800 years to decompose
                  </li>
                  <li className="flex items-center">
                    <i className="ri-close-circle-line text-red-300 mr-3"></i>
                    Ocean and soil contamination
                  </li>
                </ul>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-lg">
                <h4 className="text-xl font-bold mb-4">Our Solution</h4>
                <ul className="space-y-2">
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-300 mr-3"></i>
                    100% biodegradable in 6 months
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-300 mr-3"></i>
                    No microplastic pollution
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-300 mr-3"></i>
                    Marine waste upcycling
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-300 mr-3"></i>
                    Carbon-neutral production
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Join the Technology Revolution
          </h2>
          <p className="text-xl text-gray-600 mb-8 leading-relaxed">
            Be part of the breakthrough that's changing feminine hygiene forever. 
            Support Marine Pad and help bring this revolutionary technology to women worldwide.
          </p>
          <div className="space-y-4">
            <Link 
              to="/crowdfunding" 
              className="inline-block bg-gradient-to-r from-teal-600 to-blue-600 text-white px-12 py-4 rounded-full text-xl font-bold hover:from-teal-700 hover:to-blue-700 transition-colors whitespace-nowrap"
            >
              Support Our Campaign
            </Link>
            <p className="text-lg text-gray-500">
              Help us scale production and make this technology accessible to all
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <h4 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
                Marine Pad
              </h4>
              <p className="text-gray-400">
                A gift from the sea, a revolution for our bodies.
              </p>
            </div>
            <div>
              <h5 className="font-bold mb-4">Technology</h5>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/technology" className="hover:text-white transition-colors cursor-pointer">Bio-SA Innovation</Link></li>
                <li><Link to="/sap-dangers" className="hover:text-white transition-colors cursor-pointer">SAP Dangers</Link></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Research</a></li>
              </ul>
            </div>
            <div>
              <h5 className="font-bold mb-4">Company</h5>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/" className="hover:text-white transition-colors cursor-pointer">Our Story</Link></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Team</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Contact</a></li>
              </ul>
            </div>
            <div>
              <h5 className="font-bold mb-4">Support</h5>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/crowdfunding" className="hover:text-white transition-colors cursor-pointer">Campaign</Link></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">FAQ</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Contact</a></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 Marine Pad. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors cursor-pointer">Website Builder</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}